import React from "react";
import { Typography, Icon, Switch, Card, Tag } from "@ann/web-components";
import {
  ToolCardContent,
  ToolCardHeader,
  ToolCardDescription,
  ToolCardActions,
  CardContent,
  CardWrapper,
  CircularIconButton,
  TagContainer,
} from "./ToolCard.styled";

const ToolCard = ({
  title,
  description,
  icon,
  isEnabled = false,
  onToggle,
  onSettings,
  onDelete,
  toolData,
  requiresSetup = false,
}) => {
  return (
    <CardWrapper>
      <Card onClick={() => {}} size="medium">
        <CardContent>
          <ToolCardContent $requiresSetup={requiresSetup}>
            <ToolCardHeader>
              <Typography category="subtitle" size="medium" weight="bold">
                {title}
              </Typography>
              {requiresSetup && (
                <TagContainer>
                  <Tag
                    text="Set up required"
                    color="alert"
                    size="small"
                  />
                </TagContainer>
              )}
            </ToolCardHeader>
            <ToolCardDescription>
              <Typography category="body" size="small" weight="regular">
                {description}
              </Typography>
            </ToolCardDescription>
          </ToolCardContent>
          <ToolCardActions>
            <Switch 
              checked={isEnabled} 
              onChange={onToggle} 
              size="small" 
              disabled={requiresSetup}
            />
            <CircularIconButton onClick={() => onSettings(toolData)}>
              <Icon name="settings" size="small" />
            </CircularIconButton>
            <CircularIconButton onClick={onDelete}>
              <Icon name="delete" size="small" />
            </CircularIconButton>
          </ToolCardActions>
        </CardContent>
      </Card>
    </CardWrapper>
  );
};

export default ToolCard;

